import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Studyak from "./components/MyRouter";
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import ReactGA from 'react-ga4';

// ✅ Initialize Google Analytics
ReactGA.initialize('G-33GJGRFCEB');
ReactGA.send('pageview');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter basename='/'>
    <Studyak />
  </BrowserRouter>
);

reportWebVitals();
